import { render, staticRenderFns } from "./HourBalanceWidget.vue?vue&type=template&id=4e406bb7&scoped=true&"
import script from "./HourBalanceWidget.vue?vue&type=script&lang=js&"
export * from "./HourBalanceWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e406bb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e406bb7')) {
      api.createRecord('4e406bb7', component.options)
    } else {
      api.reload('4e406bb7', component.options)
    }
    module.hot.accept("./HourBalanceWidget.vue?vue&type=template&id=4e406bb7&scoped=true&", function () {
      api.rerender('4e406bb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/planning/widgets/HourBalanceWidget.vue"
export default component.exports